<template>
  <div class="add-to-cart-holder">
    <form class="add-to-cart" v-if="sku" :name="'product-' + sku" method="POST" v-on:submit="addToCart(sku, quantity, $event)">


      <div v-if="xs === 'true'">
            <span class="tooltip-holder text-left xs">
                <div class="d-block quantity-label w-100">Aantal stuks</div>

                <div class="d-flex align-items-center">
                    <input title="quantity" v-model="quantity" class="quantity mr-4" type="number" :min="(minimumOrderQuantity / 1)" max="99999" :step="(quantityStep / 1)" required >

                    <button type="submit" :disabled="addingToCart" class="btn btn-buy btn-progress full-width">
                        <span v-if="!addingToCart"><i class="fa fa-shopping-cart "></i></span>
                        <span class="progress-bar cart" v-bind:class="{ checkmark: showCheckMark }" role="progressbar" v-bind:style="{width: progress + '%'}" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"></span>
                    </button>
                </div>
            </span>
      </div>
      <div v-else>
        <div class="mtl small-text">
          Hoeveel {{unitMeasureCode | quantityPlural(2)}} wilt u bestellen?
          <div v-if="(realMinimumOrderQuantity && realMinimumOrderQuantity !== minimumOrderQuantity && showRealMinimumOrderQuantityMessage)"><strong class="tiny-text">Minimaal {{realMinimumOrderQuantity}} {{unitMeasureCode | quantityPlural(realMinimumOrderQuantity)}}</strong></div>
        </div>
        <div class="alert alert-warning" v-if="errorMessage" v-html="errorMessage" v-on:click="showProductMultiplierExplanation()"></div>
        <span class="tooltip-holder">
                <input :name="'quantity-' + sku" :ref="'quantity-' + sku" title="quantity" v-model="quantity" class="quantity" type="number" :min="(minimumOrderQuantity / 1)" max="99999" :step="(quantityStep / 1)" required >
                <span class="quantity-label text-capitalize mrs">{{unitMeasureCode | quantityPlural(quantity)}}</span>
            </span>

        <button type="submit" :disabled="addingToCart" class="btn btn-buy btn-progress mt-3 full-width" @click="preventModalBug">
          <span v-if="!addingToCart">In winkelwagen</span>
          <span class="progress-bar cart" v-bind:class="{ checkmark: showCheckMark }" role="progressbar" v-bind:style="{width: progress + '%'}" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"></span>
        </button>
      </div>
    </form>

    <b-modal v-if="modalAddedToCartId" :ref="modalAddedToCartId" size="lg" :id="modalAddedToCartId" hide-footer title="Toegevoegd aan uw winkelwagen" style="z-index: 0;">
      <div v-if="cart && itemAdded" class="product col-12">
        <div class="row">
          <div class="col-12 col-sm-7">
            <div class="row">
              <div class="col-12 col-sm-4">
                <div class="product-image text-center">
                  <img class="img-fluid inline-block" v-if="itemAdded.meta && itemAdded.meta.ImageUrl" :src="itemAdded.meta.ImageUrl" :alt="itemAdded.name" :title="itemAdded.name">
                </div>
              </div>
              <div class="col-12 col-sm-8">
                <h3 class="product-title clickable"><span>{{qtyAdded}} x </span>{{itemAdded.name}}</h3>
                <div class="hidden-sm-down" >
                  <p class="mb-0 mt-4">Artikelnummer: {{itemAdded.id}}</p>
                </div>
                <p class="green-text">
                                <span v-if="priceIncludingTax">
                                    <strong v-if="getNetPriceByPriceAndTax(itemAdded.price, itemAdded.tax) < 1">
                                        {{ getNetPriceByPriceAndTax(itemAdded.price, itemAdded.tax) | currency('€', '', 4)}}
                                    </strong>
                                    <strong v-if="itemAdded.price > 1">
                                        {{ getNetPriceByPriceAndTax(itemAdded.price, itemAdded.tax) | currency}}
                                    </strong>
                                </span>
                  <span v-else>
                                    <strong v-if="itemAdded.price < 1">
                                        {{itemAdded.price | currency('€', '', 4)}}
                                    </strong>
                                    <strong v-if="itemAdded.price > 1">
                                        {{itemAdded.price | currency}}
                                    </strong>
                                </span>
                </p>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-5 border-left border-hidden-md">
            <h4>In uw winkelwagen</h4>
            <div class="row">
              <div class="col-6">
                <strong>{{cart.count}}</strong> <span>product<span v-if="cart.count > 1" class="">en</span>
</span></div>
              <div class="col-6">
                            <span v-if="priceIncludingTax">
                                {{ cart.total | currency }}
                            </span>
                <span v-else>
                                {{ cart.subtotal | currency }}
                            </span>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                Verzending:
              </div>
              <div class="col-6">
                <span :class="{'green-text': cart.shipping === 0}">{{ cart.shipping | currency }}</span>
<!--                <span v-if="cart.shipping === 0" class="green-text">Gratis</span>-->
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-12">
                <a class="btn btn-buy" href="/checkout">Afrekenen</a>
                <a class="btn btn-transparent" href="/winkelwagen">Bekijk winkelwagen</a>
              </div>
              <div class="col-12 mt-4">
                <a class="clickable" @click="hideModal">« Verder winkelen</a>
              </div>
            </div>
          </div>
        </div>
        <div v-if="productTorques" >
          <div class="col-12">
            <h2>Gerelateerde producten</h2>
            <small>Speciaal geselecteerd voor {{itemAdded.name}}</small>
            <div class="row mt-3">
              <div v-for="(product, index) in this.productTorques" v-if="product.NetPrice" class="col-md-4 mb-3">
                <div class="boxed-item product product-sm"
                     itemscope itemtype="https://schema.org/Product"
                >
                  <div v-if="product.IsNew" class="special-banner new">Nieuw</div>
                  <a :href="/products/+ product.Slug " class="image clickable">
                    <img v-if="product.ImageUrl" itemprop="image" class="img-fluid p-4" :src="product.ImageUrl" />
                    <i v-if="!product.ImageUrl" class="fa fa-image image-placeholder"></i>
                  </a>
                  <a :href="/products/+ product.Slug " class="title clickable mb-3">
                    <span itemprop="name">{{product.Title}}</span>
                  </a>
                  <product-stock-component :product-id="product.Id"></product-stock-component>

                  <product-stock-component class="my-3 product-stock-component-quantity" :product-id="product.Id" show-quantity="true"></product-stock-component>

                  <div class="light-text small-text">
                    <p class="my-0 nowrap">Artikelnummer: <span itemprop="sku">{{product.Sku}}</span></p>
                    <p class="my-0 nowrap">Fabrikantnummer: <span itemprop="mpn">{{product.ProductCode}}</span></p>
                  </div>

                  <div class="light-text small-text mt-3">

                    <product-price-component
                        :product-id="product.Id"
                        :net-price="product.NetPrice"
                        :vat-percentage="product.VatPercentage"
                        :disposal-fee="product.DisposalFee"
                        :minimum-order-quantity="product.MinimumOrderQuantity"
                        :original-minimum-order-quantity="product.OriginalMinimumOrderQuantity"
                        :quantity="product.MinimumOrderQuantity"
                        :unit-measure-code="product.UnitMeasureCode"
                    ></product-price-component>
                  </div>

                  <div v-if="!product.NetPrice" class="notice notice-not-in-stock">
                    <p class="pan man">Voor meer informatie over dit product kunt u <a href="/contact" target="_blank">contact met ons opnemen.</a></p>
                  </div>

                  <product-add-to-cart-component v-show="product.NetPrice"
                                                 :product-id="product.Id"
                                                 :title="product.Title"
                                                 :price="product.NetPrice"
                                                 :brand="product.Brand"
                                                 :sku="product.Sku"
                                                 :unit-measure-code="product.UnitMeasureCode"
                                                 :minimum-order-quantity="product.MinimumOrderQuantity"
                                                 :quantity-step="product.QuantityStep"
                  ></product-add-to-cart-component>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal v-if="modalProductMultiplierExplanationId" :ref="modalProductMultiplierExplanationId" size="md" title="Minimale afname i.v.m. verzending" :id="modalProductMultiplierExplanationId" hide-footer hide-title>
      <div class="row">
        <div class="col-12">
          <p>Dit product kunnen we vanaf {{realMinimumOrderQuantity}} {{unitMeasureCode | quantityPlural(realMinimumOrderQuantity)}} bij u laten bezorgen. Wilt u vanaf {{ quantity }} {{unitMeasureCode | quantityPlural(quantity)}} bestellen, dan is het mogelijk om dit product bij ons af te halen in Buitenpost.</p>
        </div>

      </div>
      <div class="row mt-4">
        <div class="col-6">
          <a class="btn btn-transparent" @click="hideProductMultiplierExplanation">« Verder winkelen</a>
        </div>
        <div class="col-6">
          <a class="btn btn-buy float-right" :href="'/checkout/shipping-rate?id=pickup&add_product=' + sku + ',' + quantity">Ja, ik kom afhalen</a>
        </div>
      </div>
    </b-modal>
  </div>

</template>

<script>
import PriceViewMixin from './PriceViewMixin';

export default {
  mixins: [ PriceViewMixin ],
  props: [
    'productId',
    'title',
    'price',
    'brand',
    'sku',
    'xs',
    'unitMeasureCode',
    'minimumOrderQuantity',
    'originalMinimumOrderQuantity',
    'realMinimumOrderQuantity',
    'quantityStep'
  ],

  /*
   * The component's data.
   */
  data() {
    return {
      quantity: 1,
      quantityService: window.QuantityService,
      shoppingCartService: window.ShoppingCartService,
      cart: null,
      itemAdded: null,
      qtyAdded: 0,
      addingToCart: false,
      progress: 0,
      showCheckMark: false,
      modalAddedToCartId: '',
      modalProductMultiplierExplanationId: '',
      productTorques: '',
      zIndex: 0,
      errorMessage: '',
      showRealMinimumOrderQuantityMessage: true,
      productMultiplierExplanationActive: false
    };
  },

  /**
   * Prepare the component (Vue 2.x).
   */
  mounted() {
    this.prepareComponent();
  },

  methods: {

    close: function () {
      let appHeader = document.getElementsByClassName("sticky-header");
      if(typeof appHeader[0] !== 'undefined') {
        appHeader[0].style.zIndex = "51";
      }

      this.$emit('close');
    },

    /**
     * Prepare the component (Vue 2.x).
     */
    prepareComponent() {
      this.quantity = this.minimumOrderQuantity;
      setTimeout(()=>{this.quantityService.setQuantity(this.productId, this.quantity);                }, 300);

      this.modalAddedToCartId = 'modalAddedToCart-'+ this.guidGenerator();
      this.modalProductMultiplierExplanationId = 'modalProductMultiplierExplanation-'+ this.guidGenerator();

      bus.$on('shopping-cart-item:add:start', function(sku) {
        if(sku === this.sku && this.addingToCart) {
          this.progress = 75;
        }

      }.bind(this));

      bus.$on('shopping-cart-item:add:end', function(sku, data) {
        if(sku === this.sku && this.addingToCart) {
          this.addingToCart = false;

          if(typeof data.error !== 'undefined') {
            this.progress = 110;

            this.animateAddToCartButton(false);
            this.errorMessage = data.message;
            this.$refs['quantity-' + sku].focus();
            return;
          }


          if (typeof data.cart !== 'undefined') {
            this.cart = data.cart;
          }

          if (typeof data.added !== 'undefined') {
            this.itemAdded = data.added;
          }

          if (typeof data.qtyAdded !== 'undefined') {
            this.qtyAdded = data.qtyAdded;
          }
          this.progress = 110;

          this.animateAddToCartButton();

          this.$refs[this.modalAddedToCartId].show();
          this.addingToCart = false;
          this.pushToGoogleTagManager(this.qtyAdded, this.itemAdded.name, this.itemAdded.id, this.itemAdded.price, this.itemAdded.meta);
          this.getProductTorques();
        }
      }.bind(this));

      bus.$on('shopping-cart-changed', function(cart) {
        this.cart = cart;
        if(typeof cart.items[this.sku] !== 'undefined') {
          this.showRealMinimumOrderQuantityMessage = false;
        }
      }.bind(this));
    },

    addToCart(sku, qty, event) {
      this.addingToCart = true;
      if (event) event.preventDefault();
      let hash = this.$cookie.get(this.shoppingCartService.getHashKey());
      this.addingToCart = true;
      this.errorMessage = '';
      this.shoppingCartService.addToCart(sku, qty, hash);
    },

    pushToGoogleTagManager(qty, title, sku, price, meta) {
      try {
        if(window.useGA4) {
          let item = {
            'item_name': String(title),
            'item_id': String(sku),
            'price': parseFloat(price).toFixed(2),
            'quantity': qty,
            'index': 1,
          };
          if(typeof meta.Categories !== 'undefined' ) {
            meta.Categories.forEach(function(category, index){
              let key = 'item_category';
              if(index > 0) {
                key += (index+1);
              }
              item[key] = category.Title.replace(/[^\w\s]/gi, '');
            })
          }

          if(typeof meta.Brand !== 'undefined' ) {
            item.item_brand = meta.Brand.replace(/[^\w\s]/gi, '');
          }
          window.dataLayer.push({
            'event': 'add_to_cart',
            'ecommerce': {
              'items': [item]
            }
          });
        } else {
          window.dataLayer.push({
            'event': 'addToCart',
            'ecommerce': {
              'currencyCode': 'EUR',
              'add': {
                'products': [{
                  'name': title.replace(/[^\w\s]/gi, ''),
                  'id': sku,
                  'price': price,
                  'category': 'Bouwmaterialen > Energie- en elektriciteitsbenodigdheden',
                  'quantity': qty
                }]
              }
            }
          });
        }

      }
      catch(err) {
        console.log(err);
      }

    },

    getProductTorques() {
      let config = {
        'params': {
          'limit': 6
        }
      };
      axios.get('/api/products/' + this.productId + '/torques', config)
          .then(response => {
            this.loading = false;
            this.productTorques = response.data;
          });
    },

    animateAddToCartButton(success = true) {
      let self = this;
      setTimeout(
          function(){ self.progress = 100; self.showCheckMark = success; }, 500,
      );
      setTimeout(
          function(){ self.progress = 0; }, 2000,
      );
      setTimeout(
          function(){  self.showCheckMark = false; }, 2500,
      );
    },

    hideModal () {
      this.$refs[this.modalAddedToCartId].hide()
    },

    preventModalBug () {
      if ($('body').hasClass('modal-open')) {
        $('body').removeClass('modal-open');
        $('body').css('padding-right', 0);
      } else {

        if ($('.modal.show')[0]) {
          $('body').addClass('modal-open');
        }
      }
    },

    guidGenerator () {
      let S4 = function() {
        return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
      };
      return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
    },

    showProductMultiplierExplanation() {
      this.$refs[this.modalProductMultiplierExplanationId].show();
    },

    hideProductMultiplierExplanation() {
      this.$refs[this.modalProductMultiplierExplanationId].hide();
    }
  },

  watch: {
    quantity: function(val, oldVal){
      if(val !== oldVal) {
        this.quantityService.setQuantity(this.productId, this.quantity);
      }
    }
  }
}
</script>